import { memo } from 'react';
import classes from 'classnames';
import { useTranslation } from 'react-i18next';
import EnvelopeIcon from '@/assets/icons/envelope.svg?react';
import PhoneIcon from '@/assets/icons/phone.svg?react';
import Link from '@/components/Link/Link';
import styles from './Footer.module.scss';

export type Props = {
  className?: string;
  dataTest?: string;
};

const links = {
  terms_and_conditions: `${
    import.meta.env.VITE_HOMEPAGE_URL
  }/obchodni-podminky/smlouva-o-uveru`,
  privacy_policy: `${
    import.meta.env.VITE_HOMEPAGE_URL
  }/obchodni-podminky/ochrana-osobnich-udaju`,
};

const FooterMemo = memo(function Footer({ className, dataTest }: Props) {
  const { t } = useTranslation(['footer', 'common']);
  return (
    <footer
      data-test={dataTest}
      className={classes(styles.container, className)}
    >
      <div className={styles.left}>
        <div className={styles.contacts}>
          <div className={styles.contact}>
            <EnvelopeIcon
              className={styles.envelope}
              data-test={`${dataTest}-envelope-icon`}
            />
            <a
              data-test="footer-mail"
              href={`mailto:${t('common:email')}`}
              className={styles.link}
            >
              {t('common:email')}
            </a>
          </div>
          <div className={styles.contact}>
            <PhoneIcon
              className={styles.phone}
              data-test={`${dataTest}-phone-icon`}
            />
            <a
              data-test="footer-number"
              href={`tel:${t('common:phone_link')}`}
              className={styles.link}
            >
              {t('common:phone')}
            </a>
          </div>
        </div>
      </div>
      <div className={styles['small-links']}>
        <Link
          to={links.terms_and_conditions}
          external
          size="s"
          className={styles['small-link']}
          dataTest={`${dataTest}-terms-conditions-link`}
        >
          {t('terms_and_conditions')}
        </Link>
        <Link
          to={links.privacy_policy}
          external
          size="s"
          className={styles['small-link']}
          dataTest={`${dataTest}-policy-link`}
        >
          {t('privacy_policy')}
        </Link>
      </div>
    </footer>
  );
});

export default FooterMemo;
